import React, { useContext, useState, useEffect } from 'react';
import { FormControl, Grid, MenuItem, Select, styled, Typography } from '@mui/material';
import { LanguageContext } from '../../../../../../../../libs/Context';
import { useSearchParams } from 'react-router-dom';

const StatusFilter = (props) =>
{
	const {
		value,
		onChange,
		statusFilterLabel
	} = props;

	const StatusMenus = [
		{ label: 'All', value: 'all' },
		{ label: 'Drafts', value: 'drafts' },
		{ label: 'Published', value: 'published' },
		{ label: 'Unpublished', value: 'unpublished' },
		{ label: 'Scheduled', value: 'scheduled' }
	];

	const [ searchParams, setSearchParams ] = useSearchParams();
	const queryParamValue = searchParams.get('statusFilter');
	const [ localValue, setLocalValue ] = useState(queryParamValue || 'all');
	const isControlled = value !== undefined && onChange !== undefined;
	const { language } = useContext(LanguageContext);

	// Initialize from URL query param if not controlled
	useEffect(() =>
	{
		if (!isControlled)
		{
			setLocalValue(queryParamValue || 'all');
		}
	}, [ queryParamValue ]);

	const handleSelectChange = (event) =>
	{
		const newValue = event.target.value;

		if (isControlled)
		{
			onChange(newValue);
		}
		else
		{
			setLocalValue(newValue);

			// Update query params
			searchParams.set('statusFilter', newValue);
			setSearchParams(searchParams);
		}
	};

	// Determine which value to use based on whether component is controlled
	const displayValue = isControlled ? value : localValue;

	const getSelectDisplay = () =>
	{
		const selectedItem = StatusMenus.find((item) => item.value === displayValue);

		return selectedItem ? selectedItem.label : '';
	};

	const CustomSelect = styled(Select)({
		backgroundColor                      : '#F8F9FA',
		border                               : 'none',
		borderRadius                         : '4px',
		boxShadow                            : 'none',
		minWidth                             : '220px',
		'& .MuiOutlinedInput-notchedOutline' : {
			border : 'none'
		},
		'&:hover' : {
			backgroundColor : '#3FBBE11A'
		},
		'& .MuiSelect-select' : {
			padding  : '4px 10px',
			fontSize : 'var(--pixel14)'
		}
	});

	return (
		<Grid item>
			<Typography pb={0.2} color={'var(--darkgray)'} fontSize={'var(--pixel10)'}>
				{statusFilterLabel || language?.status}
			</Typography>
			<FormControl fullWidth>
				<CustomSelect
					value={displayValue}
					onChange={handleSelectChange}
					id='custom-range-select'
					renderValue={getSelectDisplay}
				>
					{StatusMenus.map((item, index) => (
						<MenuItem
							key={item.value}
							value={item.value}
							sx={{
								padding : '12px 16px'
							}}
						>
							{item.label}
						</MenuItem>
					))}
				</CustomSelect>
			</FormControl>
		</Grid>
	);
};

export default StatusFilter;